import { useMutation } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { errorHandler } from '@app/utils/errorHandler';
import { BI_BASE_URL } from '@app/contstants/endpoints';

export const fetch = async (): Promise<string> => {
  const response = await api.get<{ date: string }>(`${BI_BASE_URL}/helpers/report/last_date/`);

  return response.data.date ?? [];
};

export const useReportLastSyncDate = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetch,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
